// extracted by mini-css-extract-plugin
module.exports = {"normal":"Input_normal__2-wvr","label":"Input_label__3fw61","input":"Input_input__2Dvoz","textarea":"Input_textarea__14PsB"};